import merge from 'lodash/merge';
import BN_Asam4LevelOfCareCriteriaTerminologyLevel from './BN_Asam4LevelOfCareCriteriaTerminologyLevel';
import DomainResource from './DomainResource';

export default class BN_Asam4LevelOfCareCriteriaTerminology extends DomainResource {
    static _className = 'BN_Asam4LevelOfCareCriteriaTerminology';

    _objectStructure = {
        levels: [BN_Asam4LevelOfCareCriteriaTerminologyLevel],
    };

    constructor(constructJson, className = 'BN_Asam4LevelOfCareCriteriaTerminology') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson, this._objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
